let _newsGraphOriginalTitleAndDateParent = null;
let _newsGraphOriginalTitleAndDateNextSibling = null;
let _newsGraphActiveFilter = null;

const getNewsGraphTargetElements = () => [
    document.querySelector('.filters-container'),
    document.querySelector('.fullscreen-toggle'),
    document.querySelector('.main-controls'),
    document.querySelector('.bottom-player-area')
];


window.exitNewsGraphMode = function(restoreFilter = false, skipTickerNewsReset = false) {
    document.body.classList.remove('news-graph-active');
    const isNewsGraphActive = !!window._newsGraphInstance;

    if (window._newsGraphInstance) {
        window._newsGraphInstance.destroy();
        window._newsGraphInstance = null;
    }

    const elementsToRestore = getNewsGraphTargetElements();
    
    elementsToRestore.forEach(el => {
        if (el && el.dataset.newsGraphHidden === 'true') {
            el.style.display = el.dataset.oldDisplay || '';
            delete el.dataset.newsGraphHidden;
            delete el.dataset.oldDisplay;
        }
    });

    const titleAndDate = document.querySelector('.title-and-date');
    if (titleAndDate && _newsGraphOriginalTitleAndDateParent) {
        if (_newsGraphOriginalTitleAndDateNextSibling && _newsGraphOriginalTitleAndDateNextSibling.parentNode === _newsGraphOriginalTitleAndDateParent) {
            _newsGraphOriginalTitleAndDateParent.insertBefore(titleAndDate, _newsGraphOriginalTitleAndDateNextSibling);
        } else {
            _newsGraphOriginalTitleAndDateParent.appendChild(titleAndDate);
        }
        _newsGraphOriginalTitleAndDateParent = null;
        _newsGraphOriginalTitleAndDateNextSibling = null;
    }

    const closeBtn = document.querySelector('#news-graph-close-btn');
    if (closeBtn) {
        closeBtn.remove();
    }

    const legend = document.getElementById('news-graph-legend');
    if (legend) legend.style.display = 'none';

    const toolbar = document.getElementById('news-graph-toolbar');
    if (toolbar) toolbar.style.display = 'none';
    const btnLegend = document.getElementById('ng-btn-legend');
    if (btnLegend) btnLegend.classList.remove('active');
    const btnRotate = document.getElementById('ng-btn-rotate');
    if (btnRotate) btnRotate.classList.remove('active');
    const btn3d = document.getElementById('ng-btn-3d');
    if (btn3d) btn3d.classList.add('active');
    const btn2d = document.getElementById('ng-btn-2d');
    if (btn2d) btn2d.classList.remove('active');



    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) newsMenuBtn.classList.remove('active');

    if (restoreFilter && isNewsGraphActive) {
        if (_newsGraphActiveFilter) {
            _newsGraphActiveFilter.click();
        } else {
            const defaultChartBtn = document.querySelector('.filters-container .item[data-action="topdollar"]');
            if (defaultChartBtn) {
                defaultChartBtn.click();
            }
        }
    }

    const ctrl = _getExistingTickerNewsComponent();
    if (ctrl && isNewsGraphActive && !skipTickerNewsReset) {
        ctrl.currentMode = 'market-summary';
        ctrl.data.ticker = 'BUSINESS';
        ctrl.syncFiltersUI('market-summary');
        ctrl.renderMarketSummary();
        if (ctrl.container) {
            ctrl.container.classList.remove('news-open');
            const nm = ctrl.container.querySelector('.news-mode');
            if (nm) nm.classList.remove('narrative-mode');
        }
    }

    const centerPanelContent = document.getElementById('large-center-panel-content');
    if (centerPanelContent && centerPanelContent.object3D) {
        centerPanelContent.object3D.visible = true;
    }
}

async function onNewsGraphClick() {
    document.body.classList.add('news-graph-active');
    const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
    
    _newsGraphActiveFilter = Array.from(categoryButtons).find(btn => btn.classList.contains('active')) || _newsGraphActiveFilter;
    
    categoryButtons.forEach(btn => btn.classList.remove('active'));

    const titleEl = document.querySelector('#main-container .title-and-date h2');
    if (titleEl) titleEl.innerText = 'News graph';

    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) newsMenuBtn.classList.add('active');

    const btn3dMenu = document.getElementById('ss-3d-chart-btn');
    if (btn3dMenu) btn3dMenu.classList.remove('active');

    if (document.body.dataset.isSearchMode === 'true') {
        document.dispatchEvent(new CustomEvent('close-search-screen'));
    }

    if (document.body.classList.contains('watchlist-mode')) {
        if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.Manager.exitWatchlistMode) {
            window.WatchlistApp.Manager.exitWatchlistMode(false);
        }
    }

    if (window._newsGraphInstance) {
        window._newsGraphInstance.destroy();
        window._newsGraphInstance = null;
    }

    const centerPanelContent = document.getElementById('large-center-panel-content');
    if (centerPanelContent && centerPanelContent.object3D) {
        centerPanelContent.object3D.visible = false;
    }

    const existingComp = _getExistingTickerNewsComponent();
    if (existingComp) {
        existingComp.currentMode = 'market-summary';
        existingComp.syncFiltersUI('market-summary');
        existingComp.renderMarketSummary();
    }



    const elementsToHide = getNewsGraphTargetElements();
    
    elementsToHide.forEach(el => {
        if (el && el.dataset.newsGraphHidden !== 'true') {
            el.dataset.oldDisplay = el.style.display || '';
            el.dataset.newsGraphHidden = 'true';
            el.style.display = 'none';
        }
    });

    const titleAndDate = document.querySelector('.title-and-date');
    const filtersContainer = document.querySelector('.filters-container');
    if (titleAndDate && filtersContainer && filtersContainer.parentNode) {
        if (!_newsGraphOriginalTitleAndDateParent) {
            _newsGraphOriginalTitleAndDateParent = titleAndDate.parentNode;
            _newsGraphOriginalTitleAndDateNextSibling = titleAndDate.nextSibling;
        }
        filtersContainer.parentNode.insertBefore(titleAndDate, filtersContainer);
    }

    const mainBlock = document.getElementById('main-block');
    if (mainBlock) {
        let closeBtn = document.querySelector('#news-graph-close-btn');
        if (!closeBtn) {
            closeBtn = document.createElement('div');
            closeBtn.id = 'news-graph-close-btn';
            closeBtn.className = 'center-chart-close-button';
            
            const closeIcon = document.createElement('img');
            closeIcon.src = './desktop_assets/cross.svg';
            closeIcon.alt = 'Close';
            closeBtn.appendChild(closeIcon);
            
            closeBtn.addEventListener('click', () => {
                window.exitNewsGraphMode(true);
            });
            
            const contentRow = mainBlock.querySelector('.content-row');
            if (contentRow) {
                mainBlock.insertBefore(closeBtn, contentRow);
            } else {
                mainBlock.appendChild(closeBtn);
            }
        }
    }

    const legend = document.getElementById('news-graph-legend');
    if (legend) legend.style.display = 'none';

    const toolbar = document.getElementById('news-graph-toolbar');
    if (toolbar) toolbar.style.display = 'flex';

    const apiManager = await NewsProxyAPIManager.create();
    const data = await apiManager.fetchNarrativeTickerMap();
    if (!data) return;

    const overview = document.getElementById('news-graph-overview');
    if (overview) {
        let overviewText = 'No overview available.';
        if (data.overview && data.overview.market) {
            overviewText = data.overview.market;
        } else if (data.overview && data.overview.overview) {
            overviewText = data.overview.overview;
        } else if (typeof data.overview === 'string') {
            overviewText = data.overview;
        }
        overview.classList.add('is-market-overview');
        overview.innerHTML = `
            <h3 class="news-graph-overview-title">Overview</h3>
            <p class="news-graph-overview-text">${overviewText}</p>
        `;
    }

    const chartWrapper = document.querySelector('#main-block .chart-wrapper');
    if (!chartWrapper) return;

    const viz = new NewsGraphVisualizer(chartWrapper);
    
    viz.onNodeClick = (node) => {
        const ctrl = _getExistingTickerNewsComponent();
        if (ctrl) {
            ctrl.lastNarrativeData = data;
            ctrl._pendingRelatedTopics = _buildRelatedTopicsData(node, data);
        }

        updateOverviewPanel(node, data);

        const closeDetail = (ctrl) => {
            if (ctrl && ctrl.container) {
                ctrl.container.classList.remove('news-open');
                const nm = ctrl.container.querySelector('.news-mode');
                if (nm) nm.classList.remove('narrative-mode');
            }
        };

        if (ctrl) {
            ctrl.syncFiltersUI('none');
            closeDetail(ctrl);

            if (window.NewsGraph.NARRATIVE_TYPES.has(node.type)) {
                ctrl.openNarrativeDetail(node);
            } else {
                ctrl.openTickerDetail(node, data);
            }
        }
    };

    viz.mount(data);
    window._newsGraphInstance = viz;

    _setupNewsGraphToolbar(viz);
}

function _getStockCubePriceMap() {
    const stockCube = document.querySelector('#stock-3d-cube');
    const comp = stockCube && stockCube.components && stockCube.components['stock-cube-visualizer'];
    if (!comp || !comp.stockInfo) return new Map();
    try {
        return comp.getCachedStockInfoMap();
    } catch(e) {
        return new Map();
    }
}

function _setupNewsGraphToolbar(viz) {
    const btn3d     = document.getElementById('ng-btn-3d');
    const btn2d     = document.getElementById('ng-btn-2d');
    const legend    = document.getElementById('news-graph-legend');

    if (!viz || !viz._controls) return;

    const controls = viz._controls;

    const syncRotateBtn = (active) => {
        const btn = document.getElementById('ng-btn-rotate');
        if (!btn) return;
        btn.classList.toggle('active', active);
    };

    syncRotateBtn(controls.autoRotate);

    controls.onAutoRotateChange = (active) => {
        syncRotateBtn(active);
    };

    if (btn3d) {
        btn3d.addEventListener('click', () => {
            btn3d.classList.add('active');
            if (btn2d) btn2d.classList.remove('active');
        });
    }
    if (btn2d) {
        btn2d.addEventListener('click', () => {
            btn2d.classList.remove('active');
            if (btn3d) btn3d.classList.add('active');
        });
    }

    const btnRotate = document.getElementById('ng-btn-rotate');
    if (btnRotate) {
        const newRotateBtn = btnRotate.cloneNode(true);
        btnRotate.parentNode.replaceChild(newRotateBtn, btnRotate);
        newRotateBtn.classList.toggle('active', controls.autoRotate);

        newRotateBtn.addEventListener('click', () => {
            if (controls.autoRotate) {
                controls.disableAutoRotate();
            } else {
                controls.enableAutoRotate();
            }
        });
    }

    const btnLegend = document.getElementById('ng-btn-legend');
    if (btnLegend && legend) {
        const newLegendBtn = btnLegend.cloneNode(true);
        btnLegend.parentNode.replaceChild(newLegendBtn, btnLegend);

        newLegendBtn.addEventListener('click', () => {
            const isVisible = legend.style.display !== 'none';
            legend.style.display = isVisible ? 'none' : 'flex';
            newLegendBtn.classList.toggle('active', !isVisible);
            if (window._newsGraphInstance) {
                window._newsGraphInstance._adjustCameraToFit();
            }
        });
    }
}

function handleInteraction(elementId, actionName) {
    if (window.gtag) gtag('event', actionName, { event_category: 'News Graph', event_label: elementId });
}

function _getExistingTickerNewsComponent() {
    return window._tickerNewsInstance || null;
}


function _buildRelatedTopicsData(node, data) {
    if (!node || !data) return { entries: [], narrativeMap: {}, tickerMap: {} };

    const relationships = data.relationships || [];
    const narrativeMap = {};
    (data.narratives || []).forEach(n => { narrativeMap[n.id] = n; });
    const tickerMap = {};
    (data.tickers || []).forEach(t => { tickerMap[t.id] = t; });

    const connectedRels = relationships.filter(r =>
        (r.source_id === node.id || r.target_id === node.id) &&
        r.relationship !== 'offsets'
    );

    const entries = [];
    const seen = new Set();

    const NARRATIVE_TYPES = window.NewsGraph.NARRATIVE_TYPES;
    const nodeIsNarrative = NARRATIVE_TYPES.has(node.type);

    connectedRels.forEach(r => {
        const otherId = r.source_id === node.id ? r.target_id : r.source_id;
        const otherType = r.source_id === node.id ? r.target_type : r.source_type;

        const otherIsNarrative = NARRATIVE_TYPES.has(otherType);
        const otherIsTicker = otherType === 'ticker' || otherType === 'ticker_group';

        if (!otherIsNarrative && !otherIsTicker) return;
        if (!nodeIsNarrative && otherIsTicker) return;

        if (seen.has(otherId)) return;
        seen.add(otherId);

        let item = null;
        const isTicker = otherIsTicker;
        if (isTicker) {
            item = tickerMap[otherId];
        } else {
            item = narrativeMap[otherId];
        }
        if (!item) return;

        entries.push({ item, isTicker, rel: r.relationship || '', strength: r.strength || 0 });
    });

    entries.sort((a, b) => b.strength - a.strength);
    return { entries, narrativeMap, tickerMap, data };
}

function updateOverviewPanel(node, data) {
    const overview = document.getElementById('news-graph-overview');
    if (!overview) return;

    if (!node) {
        overview.classList.add('is-market-overview');
        let overviewText = 'No overview available.';
        if (data.overview && data.overview.market) {
            overviewText = data.overview.market;
        } else if (data.overview && data.overview.overview) {
            overviewText = data.overview.overview;
        } else if (typeof data.overview === 'string') {
            overviewText = data.overview;
        }
        overview.innerHTML = `
            <h3 class="news-graph-overview-title">Overview</h3>
            <p class="news-graph-overview-text">${overviewText}</p>
        `;
        return;
    }

    overview.classList.remove('is-market-overview');

    const articleIds = node.article_ids || [];

    const articlesMap = data.articles || {};
    const sourceCardsHTML = articleIds.slice(0, 20).map(id => {
        const a = articlesMap[id];
        if (!a) return '';
        let dateStr = '';
        if (a.published_at) {
            try {
                const d = new Date(a.published_at);
                dateStr = d.toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
            } catch(e) {}
        }
        return `<div class="source-card" data-article-id="${id}">
            <div class="source-card-header">
                <span class="source-name">${(a.source || a.publisher || 'Unknown').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>
                <span class="source-date">${dateStr}</span>
            </div>
            <div class="source-card-body">
                <span class="source-title">${(a.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>
                <a class="source-open-btn" href="${(a.url || '#').replace(/"/g,'%22')}" target="_blank" rel="noopener noreferrer">Open ↗</a>
            </div>
        </div>`;
    }).filter(Boolean).join('');

    const count = articleIds.length;
    if (sourceCardsHTML) {
        overview.innerHTML = `
            <div class="detail-section">
                <h4 class="detail-section-title">Sources <span class="detail-section-count">(${count})</span></h4>
                <div class="detail-sources">${sourceCardsHTML}</div>
            </div>
        `;
    } else {
        overview.innerHTML = `<p style="color: #666; font-size: 13px; padding: 8px 0;">No sources available.</p>`;
    }

    const isMobilePortrait = document.documentElement.classList.contains('desktop-portrait-accepted') &&
                             document.documentElement.classList.contains('desktop-portrait');
    if (isMobilePortrait) {
        overview.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}
window.NewsGraph = window.NewsGraph || {};
window.NewsGraph.updateOverviewPanel = updateOverviewPanel;

document.addEventListener('DOMContentLoaded', function () {
    const btn = document.getElementById('news-graph-btn');
    if (btn) {
        btn.addEventListener('click', onNewsGraphClick);
    }

    const newsMenuBtn = document.getElementById('ss-news-btn');
    if (newsMenuBtn) {
        newsMenuBtn.addEventListener('click', (e) => {
            e.preventDefault();
            onNewsGraphClick();
        });
    }
});
